import http from "./http.js";

async function getColumnSettings(resource) {
  try {
    const response = await http.get("column-settings/" + resource);
    return response;
  } catch (err) {
    throw err;
  }
}

async function saveColumnSettings(resource, columns) {
  try {
    const response = await http.post("column-settings", {
      resource,
      settings: JSON.stringify(columns),
    });
    return response;
  } catch (err) {
    throw err;
  }
}

export { getColumnSettings, saveColumnSettings };
